<div class="section">
  <div class="row">
    <div class="col-12">
      <h3 class="title-with-icon">
        <svg-icon src="assets/images/icons/performance.svg" class="black-medium"></svg-icon>
        <span>{{ "Wired.Devices.Title" | translate }}</span>
      </h3>
      <ng-container>
        @if (!hasDevices()) {
          <div class="card">{{ "Wired.Devices.NoDevices" | translate }}</div>
        } @else {
          <div class="card">
            <ul>
              @for (device of devices.value() ?? []; track device) {
                <li>{{ device }}</li>
              }
            </ul>
          </div>
        }
      </ng-container>
    </div>
  </div>
</div>
